/* eslint-disable import/extensions */
import { IdleQueue } from 'idlize/IdleQueue.mjs'
import analytics from './ga'

const Selectors = {
  tracker: '[data-tracker-event]',
  observable: '[data-tracker-observable]',
}

const EventsAcronym = {
  swipe: 'swiped',
  click: 'clicked',
  toggle: 'toggle',
  opened: 'opened',
}

const EventsSelectAcronym = {
  change: 'clicked',
  focusin: 'opened',
}

const CustomEventsAcronym = {
  toggle: 'state',
  swipe: 'direction',
}

const SelectTag = 'SELECT'
const CustomEventsMap = ['swipe', 'opened']

const queue = new IdleQueue({
  ensureTasksRun: true,
})

const isTraceable = (target, event) => {
  return (
    target &&
    target.dataset.trackerEvent &&
    target.dataset.trackerEvent.includes(event)
  )
}

const mount = () => {
  /**
   * delegate events
   */

  document.addEventListener('click', onTrack, false)
  document.addEventListener('swipe', onTrack)
  document.addEventListener('opened', onTrack)
  document.addEventListener('change', onTrack)
  document.addEventListener('toggle', onTrack)
  document.addEventListener('focusin', onTrack)

  /**
   * observable targets
   */
  document.querySelectorAll(Selectors.observable).forEach((target) => {
    intersectionViewport(target, () => {
      queue.pushTask(() => {
        /**
         ** get action type
         * */

        const actionType = target.dataset.trackerAction

        /**
         ** send data to gtag
         * */

        analytics.send({
          type: 'exist',
          action: actionType ? `${actionType}+showed` : 'showed',
          category: target.dataset.trackerType,
        })
      })
    })
  })
}

const onTrack = ({ type, target, detail }) => {
  queue.pushTask(() => {
    /**
     * fix bubbling
     * https://gomakethings.com/checking-event-target-selectors-with-event-bubbling-in-vanilla-javascript/
     */
    const bubblingTarget = CustomEventsMap.includes(type)
      ? target
      : target.closest(Selectors.tracker)

    /**
     * bubblingTarget not found
     */
    if (!bubblingTarget) return

    /**
     * define event type
     * EventsSelectAcronym - specific events to <select>
     * EventsAcronym - another tags
     */
    const typeEvent =
      bubblingTarget.tagName === SelectTag
        ? EventsSelectAcronym[type]
        : EventsAcronym[type]

    if (isTraceable(bubblingTarget, typeEvent)) {
      /**
       ** try get detail event or native event
       * */

      const actionEvent = getEventDetail(type, detail) || typeEvent

      /**
       ** get action type
       * */

      const actionType = bubblingTarget.dataset.trackerAction

      /**
       ** send data to gtag
       * */

      analytics.send({
        type: 'event',
        action: actionType ? `${actionType}+${actionEvent}` : actionEvent,
        category: bubblingTarget.dataset.trackerType,
      })
    }
  })
}

const getEventDetail = (eventType, detail) => {
  return detail && detail[CustomEventsAcronym[eventType]]
}

const intersectionViewport = (target, callback) => {
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entrie) => {
        if (entrie.intersectionRatio > 0) {
          callback()
          observer.unobserve(target)
        }
      })
    })

    observer.observe(target)
  }
}

export default { mount }
